const FEATURE_COLORS = {
  darkBackgroundColor: {
    transaksi: "#227777",
    realokasi: "#772277",
    umk: "#227722",
    umo: "#777722",
  },
  backgroundColor: {
    transaksi: "#22dddd", // "aqua" "00ffff"
    realokasi: "#dd22dd", // "fuchsia" "ff00ff"
    umk: "#22dd22", // "lime" "#00ff00"
    umo: "#dddd22", // "yellow" "ffff00"
  },
  bootstrapColor: {
    transaksi: "info",
    realokasi: "primary",
    umk: "success",
    umo: "warning",
  },
};

export default FEATURE_COLORS;
